import React, { useMemo } from "react";
import CurrencyType from "@mpc/common/src/components/SForm/SFormElement/CurrencyType";
import { Space, Button } from "@bedrock/components";
import classNames from "classnames/bind";
import { BaseValueArg, JournalDetailAo } from "#services/api";
import { openDetailPath } from "#utils/openDetail";
import styles from './index.less'
// import "./index.less"


const cx = classNames.bind(styles);

type ViewDomProps = {
    forward?: string,
    backward?: string,
    valueStr?: string,
    valueArgs?: BaseValueArg[],
    classNames?: string,
}

function schemaToList(str) {
    let matches = str?.match(/\$\{([^}]+)\}/g);
    let result = [];
    if (matches) {
        result = matches?.map(match => ({ key: match?.slice(2, -1) }));
    } else {
        result = [str];
    }
    return result
}

function SchemaViewDom(props: ViewDomProps) {
    const { valueStr, valueArgs, forward = "", backward = "", classNames } = props
    const valueList = schemaToList(valueStr)
    function setFindObj(value) {
        switch (value?.type) {
            case 'amount':
                return (
                    <div className={cx("item-value")}>
                        <CurrencyType
                            view={true}
                            value={{
                                value: Number(value.text),
                                currency: value.currency_enum
                            }}
                            currencyColor={'black'}
                        />
                    </div>
                )
            case 'project':
                return <div className={cx("item-value")}>
                    <Button onClick={() => {
                        openDetailPath(value?.project_type, value?.project_id)
                    }} type="link">{value.text}</Button>
                </div>
            case 'user':
                return <div className={cx("item-value", 'user-item-value')}>{value?.text}</div>
            default:
                return <div className={cx("item-value")}>{value?.text}</div>
        }
    }
    return (
        <>
            {valueList.map?.((n, i) => {
                if (typeof n === 'string') {
                    return <div className={cx("item-value")}>{n}</div>
                }
                const findObj = valueArgs?.find(m => m?.key === n?.key);
                if (!findObj) return `\$\{${n?.key}\}`
                return <>
                    {setFindObj(findObj)} {i !== valueList.length - 1 && '、'}
                </>
            })}
        </>
    )
}

type Props = {
    journalList?: JournalDetailAo[]
}

const Index = (props: Props) => {
    const { journalList = [] } = props;
    const setRenderJournalSwitch = (item) => {
        switch (item.change_type) {
            case 'journal_changed_no_detail':
                return (
                    <div className={cx('render-journal-container-space')}>
                        <span className={cx('item-label')} style={{ margin: "0px 4px 0px 0px" }}>已更新</span>
                        <SchemaViewDom valueStr={item.value} valueArgs={item.value_args} />
                    </div>
                )
            case 'journal_changed':
                return (
                    <div className={cx('render-journal-container-space')}>
                        <span className={cx('item-label')} style={{ margin: "0px 4px 0px 0px" }}>从</span>
                        <SchemaViewDom valueStr={item.old_value} valueArgs={item.old_value_args} />
                        <span className={cx('item-label')} style={{ margin: '0px 4px' }}>变更为</span>
                        <SchemaViewDom valueStr={item.value} valueArgs={item.value_args} />
                    </div>
                )
            case 'journal_deleted':
                return (
                    <div className={cx('render-journal-container-space')}>
                        <SchemaViewDom valueStr={item.old_value} valueArgs={item.old_value_args} />
                        <span className={cx('item-label')} style={{ margin: '0px 4px' }}>已删除</span>
                    </div>
                )
            case 'journal_set_to':
                return (
                    <div className={cx('render-journal-container-space')}>
                        <span className={cx('item-label')} style={{ margin: "0px 4px 0px 0px" }}>设置为</span>
                        <SchemaViewDom valueStr={item.value} valueArgs={item.value_args} />
                    </div>
                )
            case 'journal_created':
                return (
                    <div className={cx('render-journal-container-space')} >
                        <SchemaViewDom valueStr={item.value} valueArgs={item.value_args} />
                        <span className={cx('item-label')} style={{ margin: '0px 4px' }}>已创建</span>
                    </div>
                )
            default:
                return <div>已更新</div>
        }
    }

    const renderJournalList = useMemo(() => {
        const result = journalList.map(item => {
            const { extra_keys = {} } = item;
            const isPayAdvanced = extra_keys['pay_advanced'];
            let name = `${item.field}`;
            return (
                <Space className={cx('render-journal-container-space')} size={8} align="baseline">
                    <div className={cx('item-label')}>{name}:</div>
                    {setRenderJournalSwitch(item)}
                </Space>
            )
        })
        return result
    }, [journalList])

    return (
        <div className={cx("render-journal-container")}>{renderJournalList}</div>
    )
}

export default Index;